module.exports = __webpack_public_path__ + "static/media/sun.da10f053.svg";